<template>
  <div>
    <div
      class="modal animated fadeIn"
      id="weeklylabourModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Labour charges</small
                >
              </legend>
              <form @submit.prevent="loadtruckLabours()">
                <div class="row">
                  <input type="hidden" class="truck_id" :value="Truck.id" />
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control from_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control end_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn btn-danger btn-flat"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingTrucklabour"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingTrucklabourLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal animated fadeIn"
      id="fullweeklylabourModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Labour charges</small
                >
              </legend>
              <form @submit.prevent="loadfullLabours()">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control full_from_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control full_end_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Transporter</label>
                      <select class="form-control transporter_id">
                        <option value>select Transporter</option>
                        <option
                          v-for="transporter in systemTransporters"
                          :value="transporter.id"
                          :key="transporter.id"
                        >
                          {{ transporter.transporter_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn btn-danger btn-flat"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingFullLabours"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingFullLaboursLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal animated fadeIn"
      id="fullnumberlesslabourModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Numberless Labour charges</small
                >
              </legend>
              <form @submit.prevent="loadfullNumberlessLabours()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control numberless_from_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control numberless_end_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn btn-danger btn-flat"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingNumberlessLabours"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingNumberlessLaboursLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage truck labour charges</div>
            <fieldset class="border p-3">
              <button
                type="button"
                class="btn btn-success btn-roundec"
                data-toggle="modal"
                data-target="#fullweeklylabourModal"
              >
                <i class="fa fa-file-pdf-o"></i> General Labour Charges
              </button>
              <p></p>
              <div></div>
              <button
                type="button"
                class="btn btn-success btn-roundec"
                data-toggle="modal"
                data-target="#fullnumberlesslabourModal"
              >
                <i class="fa fa-file-pdf-o"></i> General Numberless Labour
                Charges
              </button>

              <div></div>
              <div>
                <div class="trucksLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >loading trucks...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemTrucks"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'faulty_status'">
                      <span v-if="props.row.Faulty_status === 0">
                        <button class="btn btn-info btn-sm btn-flat">
                          <i class="fa fa-level-up"></i> NOT FAULTY
                        </button>
                      </span>
                      <span v-else-if="props.row.Faulty_status === 1">
                        <button class="btn btn-danger btn-sm">
                          <i class="fa fa-level-down"></i> FAULTY
                        </button>
                      </span>
                    </span>

                    <span v-if="props.column.field == 'Action'">
                      <button
                        type="button"
                        class="btn btn-primary btn-roundec"
                        data-toggle="modal"
                        data-target="#weeklylabourModal"
                        @click="viewTrucks(props.row.id)"
                      >
                        <i class="fa fa-file-pdf-o"></i> Labour charges
                      </button>
                    </span>
                    <span v-else>{{
                      props.formattedRow[props.column.field]
                    }}</span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Transporter name",
          field: "transporter_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter transporter",
          },
        },
        {
          label: "Truck number",
          field: "truck_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter truck number",
          },
        },
        {
          label: "Trailer number",
          field: "trailer_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter trailer no",
          },
        },
        
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true,
        },
      ],
    };
  },
  created() {
    this.loadTrucks();
    this.loadTransporters();
  },
  computed: {
    ...mapGetters(["systemTrucks", "Truck", "systemTransporters"]),
  },
  methods: {
    ...mapActions([
      "loadTrucks",
      "viewTrucks",
      "loadtruckLabours",
      "loadfullLabours",
      "loadfullNumberlessLabours",
      "loadTransporters",
    ]),
  },
};
</script>
<style scoped>
.creatingTrucklabourLoader {
  display: none;
}
.creatingFullLaboursLoader {
  display: none;
}
.creatingNumberlessLaboursLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/reports/labourcharges.vue